import { render, staticRenderFns } from "./Bookkeeper.vue?vue&type=template&id=7e77eccc"
import script from "./Bookkeeper.vue?vue&type=script&lang=js"
export * from "./Bookkeeper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/websites/streamlined-business-solutions/sbs-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7e77eccc')) {
      api.createRecord('7e77eccc', component.options)
    } else {
      api.reload('7e77eccc', component.options)
    }
    module.hot.accept("./Bookkeeper.vue?vue&type=template&id=7e77eccc", function () {
      api.rerender('7e77eccc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/Bookkeeper.vue"
export default component.exports